<template>

<div id="listing-card-page" class="user-mh-100">
    <div class=" mb-0"></div>
    <section id="filter_options_Section" class="mt-2">
        <!-- Desktop Menu -->
        <div class="bg-white">
            <form action="" method="post" @submit.prevent="submit">
                <div class="filterBar">
                    <div id="container">
                        <nav class="navBar">
                            <ul class="ul-nav">
                                <!-- Date -->
                                <li class="nav-item" v-if="data.productType == 'daily'">
                                    <DateRangeButton :options="dateOptions" v-model="f.date" :default-title="dateTitle" @changed="submit" />
                                </li>
                                <!-- Country -->
                                <li class="nav-item dropdown">
                                    <a class="nav-link dropdown-toggle" href="javascript:void(0);"
                                       role="button" data-bs-toggle="dropdown" aria-expanded="false">
                                        {{ $filters.initCap(data.countries.find((p) => p.id == f.country)?.title || 'Country') }}
                                    </a>
                                    <ul class="dropdown-menu filterDropdownMenu" aria-labelledby="filterNavbarCountry">
                                        <li class="w-100" v-for="country in data.countries">
                                            <a :class="['dropdown-item ', f.country == country.id ? 'active bg-warning text-dark' : '']" href="javascript:void(0);" @click="f.country = country.id; submit();">
                                                {{  $filters.initCap(country.title) }}
                                            </a>
                                        </li>
                                    </ul>
                                </li>
                                <!-- Category -->
                                <li class="nav-item dropdown">
                                    <a class="nav-link dropdown-toggle" href="javascript:void(0);" role="button" data-bs-toggle="dropdown" aria-expanded="false">
                                        {{  $filters.initCap(data.categories.find((c) => c.id == f.category)?.title || 'All Categories') }}
                                    </a>
                                    <ul class="dropdown-menu filterDropdownMenu" aria-labelledby="filterNavbarCategory" style="overflow-y: auto; height: 500px;">
                                        <li class="w-100"><a class="dropdown-item" href="javascript:void(0);" @click="f.category = '-1'; submit();">All Categories</a></li>
                                        <li class="w-100" v-for="category in data.categories">
                                            <a :class="['dropdown-item ', f.category == category.id ? 'active bg-warning text-dark' : '']"
                                               href="javascript:void(0);" @click="f.category = category.id;submit();">{{  $filters.initCap(category.title) }}</a>
                                        </li>
                                    </ul>
                                </li>
                                <!-- Sorting -->
                                <li class="nav-item dropdown">
                                    <a class="nav-link dropdown-toggle" href="javascript:void(0);" id="filterNavbarSortBy" role="button" data-bs-toggle="dropdown" aria-expanded="false">
                                        {{  data.sortList[f.sort] || 'Sort By' }}
                                    </a>
                                    <ul class="dropdown-menu filterDropdownMenu" aria-labelledby="filterNavbarSortBy">
                                        <li class="w-100" v-for="(title,id) in data.sortList">
                                            <a :class="['dropdown-item ', f.sort == id ? 'active' : '']" href="javascript:void(0);" @click="f.sort = id;submit();">{{ title }}</a>
                                        </li>
                                    </ul>
                                </li>
                            </ul>
                        </nav>
                    </div>
                    <div class='search-bar'>
                        <input class="search-bar__input" type="text" id="search-input" v-model="f.title" autocomplete="off" placeholder="Enter your search..." />
                        <label class="search-bar__trigger" for="search-input">
                            <UserSearchIcon /> Search</label>
                        <!-- Reset Button -->
                        <button v-if="f.rf == 1" type="button" class="btn btn-sm btn-outline-light ml5 text-dark" @click="clearFilters" title="Reset Filter">
                            <i class="fa fa-2x fa-times text-danger"></i>
                        </button>
                        <button type="button" class="btn btn-sm btn-outline-light ml5 text-dark" @click="showExport" title="Export"><i class="fa fa-2x fa-download"></i></button>
                    </div>
                </div>
            </form>
        </div>
        <!-- Mobile Menu -->
        <div class="bg-white">
            <form action="" method="post" @submit.prevent="submit">
            <h1 class="heading" onclick="filterBarCollapse()">Filters <span style="font-size: xx-large; font-weight: bolder; padding-left: 8px;">+</span></h1>
            <div id="container-mobile">
                <div class="filterBar-mobile">
                    <div id="Bar-container">
                        <nav class="navBar">
                            <ul class="ul-nav ul-nav-mobile">
                                <!-- Date -->
                                <li class="nav-item" v-if="data.productType == 'daily'">
                                    <DateRangeButton :options="dateOptions" v-model="f.date" :default-title="dateTitle" @changed="submit" />
                                </li>
                                <!-- Country -->
                                <li class="nav-item dropdown text-center w-50">
                                    <a class="nav-link dropdown-toggle" href="javascript:void(0);"
                                       role="button" data-bs-toggle="dropdown" aria-expanded="false">
                                        {{ $filters.initCap(data.countries.find((p) => p.id == f.country)?.title || 'Country') }}
                                    </a>
                                    <ul class="dropdown-menu filterDropdownMenuMobile" aria-labelledby="filterNavbarCountry">
                                        <li class="w-100" v-for="country in data.countries">
                                            <a :class="['dropdown-item ', f.country == country.id ? 'active bg-warning text-dark' : '']" href="javascript:void(0);" @click="f.country = country.id; submit();">
                                                {{  $filters.initCap(country.title) }}
                                            </a>
                                        </li>
                                    </ul>
                                </li>
                                <!-- Category -->
                                <li class="nav-item dropdown text-center w-50">
                                    <a class="nav-link dropdown-toggle" href="javascript:void(0);" role="button" data-bs-toggle="dropdown" aria-expanded="false">
                                        {{  $filters.initCap(data.categories.find((c) => c.id == f.category)?.title || 'All Categories') }}
                                    </a>
                                    <ul class="dropdown-menu filterDropdownMenuMobile" aria-labelledby="filterNavbarCategory" style="overflow-y: auto; height: 500px;">
                                        <li class="w-100"><a class="dropdown-item" href="javascript:void(0);" @click="f.category = '-1'; submit();">All Categories</a></li>
                                        <li class="w-100" v-for="category in data.categories">
                                            <a :class="['dropdown-item ', f.category == category.id ? 'active bg-warning text-dark' : '']"
                                               href="javascript:void(0);" @click="f.category = category.id;submit();">{{  $filters.initCap(category.title) }}</a>
                                        </li>
                                    </ul>
                                </li>
                                <!-- Sorting -->
                                <li class="nav-item dropdown text-center w-50">
                                    <a class="nav-link dropdown-toggle" href="javascript:void(0);" role="button" data-bs-toggle="dropdown" aria-expanded="false">
                                        {{  data.sortList[f.sort] || 'Sort By' }}
                                    </a>
                                    <ul class="dropdown-menu filterDropdownMenuMobile" aria-labelledby="filterNavbarSortBy">
                                        <li class="w-100" v-for="(title,id) in data.sortList">
                                            <a :class="['dropdown-item ', f.sort == id ? 'active' : '']" href="javascript:void(0);" @click="f.sort = id;submit();">{{ title }}</a>
                                        </li>
                                    </ul>
                                </li>
                            </ul>
                        </nav>
                    </div>
                    <div class='search-bar'>
                        <input class="search-bar__input" type="text" id="search-input2" v-model="f.title" autocomplete="off" placeholder="Enter your search..." />
                        <label  class="search-bar__trigger" for="search-input2">
                            <UserSearchIcon /> Search</label>
                        <button v-if="f.rf == 1" type="button" class="btn btn-sm btn-outline-light ml5 text-dark" @click="clearFilters">
                            <i class="fa fa-2x fa-times text-danger"></i>
                        </button>
                        <button type="button" class="btn btn-sm btn-outline-light ml5 text-dark" @click="showExport" title="Export"><i class="fa fa-2x fa-download"></i></button>
                    </div>
                </div>
            </div>
            </form>
        </div>
    </section>
    <section id="listing-product-panel">
        <div class="wrapper">
            <div class="content tab-content pt-0">
                <div class="tab-pane fade show active" role="tabpanel" aria-labelledby="home-tab">
                    <div class="wrapper">
                        <PageLoading :loading="loading" />
                        <template v-if="$page.props.notices.length > 0 && $page.props.notices_show">
                            <Notice :notice="notice" :key="notice.name" v-for="notice in $page.props.notices"></Notice>
                        </template>

                        <TrendingProductUpdateTrendNotice
                            v-if="data.productType == 'weekly' && $page.props.trending_update_remaining_time"
                            :end-date="$page.props.trending_update_remaining_time"
                            :para="$page.props.trending_update_remaining_time_para"
                            :pending="$page.props.trending_update_remaining_time_status"
                        />

                        <h6 class="mb-3" v-if="haveRecord">{{ recordInfo }}</h6>
                        <template v-if="haveRecord">
                            <List v-for="v in products.data" :key="v.id" :v="v"></List>
                            <div class="mt-2">
                                <pagination :links="products.links"></pagination>
                            </div>
                        </template>
                        <template v-else>
                            <div class="mt-5 mb-5">
                                <ProductRecordNotFound :description="recordInfo" />
                            </div>
                        </template>
                    </div>
                </div>
            </div>
        </div>

        <!-- export modal -->
        <div class="modal" tabindex="-1" :id="exp.modalId">
            <div class="modal-dialog modal-dialog-centered modal-lg">
                <div class="modal-content">
                    <div class="modal-body">
                        <div class="row">
                            <div class="col-md-12 mb-3">
                                <label for="exp_exp_type">File Type</label>
                                <select id="exp_exp_type"  v-model="exp.form.export_type" class="form-control" title="File Type">
                                    <option value="csv">Csv</option>
                                    <option value="txt">Text</option>
                                    <option value="xlsx">Excel</option>
                                </select>
                            </div>
                            <div class="col-md-12 mb-3">
                                <label for="exp_exp_limit">Limit</label>
                                <select id="exp_exp_limit"  v-model="exp.form.export_limit" class="form-control" title="Limit">
                                    <option value="current">Current Page</option>
                                    <option value="100" >100</option>
                                    <option value="150" >150</option>
                                    <option value="200" >200</option>
                                    <option value="300" >300</option>
                                    <option value="500" >500</option>
                                    <option value="800" >800</option>
                                    <option value="1000" >1000</option>
                                </select>
                            </div>
                            <div class="col-md-12 mb-3">
                                <div class="form-check form-check-inline">
                                    <input class="form-check-input" name="exp_aliexpress" id="exp_aliexpress" v-model="exp.form.aliexpress" type="checkbox" value="1">
                                    <label class="form-check-label" for="exp_aliexpress">Aliexpress</label>
                                </div>
                                <div class="form-check form-check-inline">
                                    <input class="form-check-input" type="checkbox" name="exp_amazon" id="exp_amazon" v-model="exp.form.amazon" value="1">
                                    <label class="form-check-label" for="exp_amazon">Amazon</label>
                                </div>
                                <div class="form-check form-check-inline">
                                    <input class="form-check-input" type="checkbox" name="exp_alibaba" id="exp_alibaba" v-model="exp.form.alibaba" value="1">
                                    <label class="form-check-label" for="exp_alibaba">Alibaba</label>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="modal-footer">
                        <button type="button" class="btn grey btn-sm btn-outline-secondary" data-bs-dismiss="modal">Close</button>
                        <button @click="exportData" type="button" class="btn grey btn-sm btn-outline-primary" >Export</button>
                    </div>
                </div>
            </div>
        </div>
        <!-- export end modal -->

    </section>
</div>
</template>
<script>

import Pagination from "@s/Components/Inertia/IPagination";
import PageLoading from "./components/PageLoading";
import DateRangeButton from "../../../shared/Components/DateRangeButton";
import List from "./components/List";
import Notice from "./components/Notice";
import TrendingProductUpdateTrendNotice from "./components/TrendingProductUpdateTrendNotice";
import UserSearchIcon from "@s/Components/Icons/UserSearchIcon";
import ProductRecordNotFound from "./components/ProductRecordNotFound";

export default {
    name: 'ProductList',
    components: {
        ProductRecordNotFound,
        Notice,
        DateRangeButton,
        PageLoading,
        'pagination': Pagination,
        List,
        TrendingProductUpdateTrendNotice,
        UserSearchIcon
    },
    props: ["products", "data", "filters", "date", "pageTitle", "recordInfo",
        'trending_update_remaining_time',
        'trending_update_remaining_time_para', 'trending_update_remaining_time_status'
    ],
    data() {
      return {
          tf: {
            country: false,
          },
          loading: false,
          f: {... this.filters},
          routes: __st.routes,
          dateTitle: this.date.title,
          dateOptions: {
              ranges: {
                  'Today': [moment(), moment()],
                  'Yesterday': [moment().subtract(1, 'days'), moment().subtract(1, 'days')],
                  'Last 7 Days': [moment().subtract(6, 'days'), moment()],
                  'Last 10 Days': [moment().subtract(9, 'days'), moment()],
                  'Last 30 Days': [moment().subtract(29, 'days'), moment()],
                  'This Month': [moment().startOf('month'), moment().endOf('month')],
              }
          },
          exp: {
              modalId:  'trending-export-modal',
              form: {
                  export_type: 'csv',
                  export_limit: 'current',
                  aliexpress: 0,
                  amazon: 0,
                  alibaba: 0
              }
          }
      }
    },
    computed: {
        haveRecord() {
            return this.products.data.length > 0;
        }
    },
    mounted() {
        [].slice.call(document.querySelectorAll('[data-bs-toggle="tooltip"]'))
            .map((ttel) => new bootstrap.Tooltip(ttel));
    },
    created() {

        document.title = this.pageTitle;

        if(this.date.startDate) {
            this.dateOptions.startDate = this.date.startDate;
        }

        if(this.date.endDate) {
            this.dateOptions.endDate = this.date.endDate;
        }

        setTimeout(() => {
            [].slice.call(document.querySelectorAll('[data-bs-toggle="popover"]'))
                .map((ptel) => new bootstrap.Popover(ptel));
        }, 300)
    },
    methods: {
        submit() {

            this.f.rf = 1;
            var that = this;
            //this.f.title = $("#navbar-searchbar-input").val();
            let queryString = Object.keys(this.f).map(function(key) {
                if(that.f[key] == null) {
                    that.f[key] = '';
                }
                return key + '=' + that.f[key]
            }).join('&');
            const url = this.data.currentUrl+"?"+queryString;
            this.$inertia.visit(url, {
                    only: ['products',"filters", "date", "recordInfo", 'isTrendUpdating', 'notices',
                        'trending_update_remaining_time', 'trending_update_remaining_time_para'],
                    onStart: (visit) => { this.loading = true;  },
                    onFinish: (visit) => {
                        this.loading = false;
                    },
                },
            )
        },

        clearFilters() {
            const filters =  {... this.filters};
            filters.date = '' ;
            this.dateOptions.startDate = '';
            this.dateOptions.endDate = '';
            filters.category = '-1';
            filters.title = '';
            this.f = filters;
            this.f.rf = 0;
        },

        showExport() {
            (new bootstrap.Modal(document.getElementById(this.exp.modalId))).show();
        },
        exportData(){
            var that = this;
            let queryString = Object.keys(this.f).map(function(key) {
                if(that.f[key] == null) {
                    that.f[key] = '';
                }
                return key + '=' + that.f[key]
            }).join('&');

            let exportLimit = this.exp.form.export_limit;
            let extra_query = "&export=1&export_type="+this.exp.form.export_type+"&export_limit="+exportLimit+"&export_rating="+this.exp.form.export_rating+"&amazon="+this.exp.form.amazon+"&aliexpress="+this.exp.form.aliexpress+"&alibaba="+this.exp.form.alibaba;
            let url = '';
            if(exportLimit == 'current')
            {
                url = this.products.links.find((p) => p.active)?.url + extra_query;
            }
            else
            {
                url = this.products.links.find((p) => p.active)?.url + extra_query;
            }

            if(url)
            {
                location.href = url;
                const modal = bootstrap.Modal.getInstance(document.getElementById(this.exp.modalId))
                modal.hide();
                this.exp.form.aliexpress = 0;
                this.exp.form.alibaba = 0;
                this.exp.form.amazon = 0;
            }


        },
    }
}
</script>

<style>
[v-cloak] { display:none; }
</style>

